module.exports = __webpack_public_path__ + "static/media/kids.3be923bf.png";